export const environment = {
  production: false,
  globalPath: 'https://dev.elitepropertyresearch.com',
  versionPath: 'api',
  agGridLicence: 'CompanyName=Elite Property Research,LicensedApplication=https://eos.elitepropertyresearch.com/' +
  ',LicenseType=SingleApplication,LicensedConcurrentDeveloperCount=1,LicensedProductionInstancesCount=1,' +
  'AssetReference=AG-024253,ExpiryDate=6_January_2023_[v2]_MTY3Mjk2MzIwMDAwMA==49eac723e598686c9125b6de43e0d105',
  reCaptchaKey: '6Lclx5MlAAAAAB1yCd8X8yx2fyM_75_7I4vV7OYR'
};
